import XRLayer from './XRLayer';

export default XRLayer;
